import axios from 'axios';
import { createAsyncThunk, isFulfilled, isPending, isRejected } from '@reduxjs/toolkit';

import { cleanEntity } from 'app/shared/util/entity-utils';
import { IQueryParams, createEntitySlice, EntityState, serializeAxiosError } from 'app/shared/reducers/reducer.utils';
import { IUserAchievements, defaultValue } from 'app/shared/model/user-achievements.model';

export interface PdfStatusState extends EntityState<IUserAchievements> {
  status: 'APPROVED' | 'REJECTED' | null;
}
const initialState: PdfStatusState = {
  loading: false,
  errorMessage: null,
  entities: [],
  entity: defaultValue,
  updating: false,
  totalItems: 0,
  updateSuccess: false,
  status: null,
};
const updatePdfStatusApi = 'api/admin/earn-points/pdf/status';

// export const updatePdfStatus = createAsyncThunk(
//   'pdfStatus/update_pdf_status',
//   async ({ fileId, status,rejectionReason }: { fileId: string; status: 'APPROVED' | 'REJECTED' ,rejectionReason?: string;}) => {
//     // const requestUrl = `${updatePdfStatusApi}?fileId=${encodeURIComponent(fileId)}&status=${status}`;
//      const requestUrl =
//       `${updatePdfStatusApi}?fileId=${encodeURIComponent(fileId)}` +
//       `&status=${status}` +
//       (status === 'REJECTED' && rejectionReason
//         ? `&rejectionReason=${encodeURIComponent(rejectionReason)}`
//         : '');
//     return axios.put(requestUrl);
//   }
// );

/*export const updatePdfStatus = createAsyncThunk(
  'pdfStatus/update_pdf_status',
  async ({ fileId, status, rejectionReason }: { fileId: string; status: 'APPROVED' | 'REJECTED'; rejectionReason?: string }) => {
    const requestUrl = `${updatePdfStatusApi}?fileId=${encodeURIComponent(fileId)}&status=${status}`;

    const body = status === 'REJECTED' ? { rejectionReason } : {};

    return axios.put(requestUrl, body);
  }
);*/

export const updatePdfStatus = createAsyncThunk(
  'pdfStatus/update_pdf_status',
  async ({ id, status, rejectionReason }: { id: number; status: 'APPROVED' | 'REJECTED'; rejectionReason?: string }) => {
    const requestUrl = `${updatePdfStatusApi}?id=${id}&status=${status}`;

    const body = status === 'REJECTED' ? { rejectionReason } : {};

    return axios.put(requestUrl, body);
  }
);

// slice

export const PdfStatusSlice = createEntitySlice({
  name: 'pdfStatus',
  initialState,
  extraReducers(builder) {
    builder
      .addMatcher(isFulfilled(updatePdfStatus), (state, action) => {
        state.updating = false;
        state.loading = false;
        state.updateSuccess = true;
      })
      .addMatcher(isPending(updatePdfStatus), state => {
        state.errorMessage = null;
        state.updateSuccess = false;
        state.updating = true;
      });
  },
});

export const { reset } = PdfStatusSlice.actions;

// Reducer
export default PdfStatusSlice.reducer;
